import React from 'react'
import PropTypes from 'prop-types'

import { contributionPluralLowerCase } from 'features/ContributionLang'

import ProductsTableLayout from '../ProductsTableLayout'

const DonationBoxesList = (props) =>
    <ProductsTableLayout
        noDataText={`Allow supporters to make recurring or one-time ${contributionPluralLowerCase()} based on a suggested amount`}
        type="donation"
        {...props}
    />

DonationBoxesList.propTypes = {
    items: PropTypes.array,
    loading: PropTypes.bool,
}

export default DonationBoxesList
